import App from '@/App.vue'
import '@/plugins/axios'
import i18n from '@/plugins/i18n'
import vuetify from '@/plugins/vuetify'
import router from '@/router'
import store from '@/store'
import 'core-js/stable'; // Pour les polyfill notamment de recaptcha
import 'regenerator-runtime/runtime'
import Vue from 'vue'

import axios from 'axios'
import IdleVue from 'idle-vue'
import moment from 'moment'

import Utils from '@/plugins/utils'

Vue.config.productionTip = false
Vue.prototype.moment = moment

Vue.use(Utils)

// Expiration de session
const eventsHub = new Vue({
  created() {
    this.$on('idleVue_onIdle', this.onIdle)
  },
  methods: {
    onIdle() {
      // console.log('idle')
      store.dispatch('logout')
    }
  }
})
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 30 * 60 * 1000 // 30 Minutes
})

// Lecture des parametres d'un fichier "local" avant tout le reste
console.log('Lecture config/config.json')
Vue.config.devtools = true
axios.get(`${process.env.BASE_URL}config/config.json`).then(response => {
  let disableConsole = response.data.disableConsole
  if (disableConsole === true) {
    console.log = console.error = console.info = console.debug = console.warn = console.trace = function () { }
  }

  let apiURL = response.data.URL
  console.log(`apiURL=${apiURL}`)
  let maintenance = response.data.maintenance === true || false
  Vue.prototype.$maintenanceMode = maintenance

  new Vue({
    router,
    store,
    i18n,
    vuetify,

    beforeCreate: function () {
      this.$axios.defaults.baseURL = apiURL
    },

    render: h => h(App)
  }).$mount('#app')
})